import { configureStore } from '@reduxjs/toolkit';
import lockdownReducer   from '../reducers/lockdownReducer';
import kpiConfigReducer  from '../reducers/kpiConfigReducer';
import kpiDataReducer    from '../reducers/kpiDataReducer';
import filtersReducer    from '../reducers/filtersReducer';

export const store = configureStore({
	reducer: {
		lockdown:  lockdownReducer,
		kpiConfig: kpiConfigReducer,
		kpiData:   kpiDataReducer,
		filters:   filtersReducer,
	},
});
